import { Flex, Title, Paragraph } from '@bb/elements-web';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';

const NoAvailableTimeslotsBanner = ({ date }: { date?: Date }) => {
  const formattedDateStr = date
    ? moment(date).format('MMMM D, YYYY')
    : 'Selected Date';

  return (
    <StyledFlex vertical align="center" justify="center" gap="0.5rem">
      <Title level={4} dataCy="no-available-timeslots-title" textAlign="center">
        <i className="fa fa-frown-o" />
      </Title>
      <Paragraph>There are no available showing times on:</Paragraph>
      <Paragraph>{formattedDateStr}</Paragraph>
      <Paragraph>Please select a different day.</Paragraph>
    </StyledFlex>
  );
};

const StyledFlex = styled(Flex)`
  width: 100%;
  padding: 3rem 1rem;
  font-weight: bold;
  background: #fea186;
`;

export default NoAvailableTimeslotsBanner;
